import React, { useState, useEffect, useRef } from 'react'
import { setLocal as set, getLocal as get } from '../../common/utils'
import { custom } from 'devextreme/ui/dialog';
import { postUserLog } from '../../actions/common'

export default ({ timeVal, switchTabs, siteId }) => {
    const [sliderTimeObj, setSliderTimeObj] = useState(false)
    const [isTabSwitching, setIsTabSwitching] = useState(false)

    const startSlider = () => {
        if (timeVal > 0) {
            postUserLog({ event: 'Slider start', data: { action: 'Dashboad slider started', module: 'Digital Tier', section: 'slider start', siteUId: siteId, widget: 'Dashboad Slider', } })
            setIsTabSwitching(true)
            let timeObj = setInterval(switchTabs, timeVal);
            setSliderTimeObj(timeObj)
        }
    }

    const stopSlider = () => {
        postUserLog({ event: 'Slider stop', data: { action: 'Dashboad slider stopped', module: 'Digital Tier', section: 'slider stop', siteUId: siteId, widget: 'Dashboad Slider', } })
        setIsTabSwitching(false)
        clearInterval(sliderTimeObj)
    }

    const resetSlider = () => {
        setIsTabSwitching(false)
        clearInterval(sliderTimeObj)
    }

    return (
        <>
            {
                (timeVal > 0) ?
                    <div className="timer-box tab-switcher-adj" >

                        {isTabSwitching && <i title="Pause slider" onClick={stopSlider} className="fas fa-pause"></i>}

                        {!isTabSwitching && <i title="Play slider" onClick={startSlider} className="fas fa-play"></i>}

                        {/*<i onClick={resetSlider} title="Reset slider" className="fas fa-undo"></i>*/}


                    </div> : ''
            }
        </>
    )
}